/**
 * App.js Layout Start Here
 */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import { NotificationContainer } from "react-notifications";
//import LinearProgress from '@material-ui/core/LinearProgress';
// rct theme provider
import RctThemeProvider from "./RctThemeProvider";

//Main App
import DefaultLayout from "./DefaultLayout";
// app signin
import LoginPage from "./LoginPage";
import QRPage from "./QRPage";
import Calculator from "./Calculator";
// // async components
// import {
//   AsyncSessionLoginComponent,
//   AsyncSessionLockScreenComponent,
//   AsyncSessionForgotPasswordComponent,
//   AsyncSessionPage404Component,
//   AsyncSessionPage500Component,
//   AsyncTermsConditionComponent,
// } from "../components/AsyncComponent/AsyncComponent";
import { showMessage, logoutUser } from "../actions";
import { RTL } from "./providers/RTL";
import { SubdomainChecker } from "../libs";
import FixBrowser from "./FixBrowser";
/**
 * Initial Path To Check Whether User Is Logged In Or Not
 */
const InitialPath = ({ component: Component, authUser, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      authUser ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/signin",
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

class App extends Component {
  firstLoad = true;
  render() {
    const { location, match, user, showMessage, logoutUser } = this.props;
    console.log("reached App js ...");
    //don't check if is requesting qr insurance
    // if (this.firstLoad && !window.location.href.includes("QRInsurance")) {
    //   this.firstLoad = false;
    //   //check user subdomain
    //   SubdomainChecker.check(
    //     user,
    //     logoutUser,
    //     showMessage
    //   );
    // }

    //check permisions
    let isPermitted = true, //general rule: permit all
      pathArray = location.pathname.split("/");
    if (user && pathArray[2] === "supplier-bills") {
      const invoices = user.permissions?.invoices;
      if (pathArray[3] === "view-all") {
        isPermitted = !!(
          invoices?.["view-all"] || invoices?.["create"]
        );
      } else if (pathArray[3] === "create") {
        isPermitted = !!invoices?.["create"];
      } else {
        isPermitted = false;
      }
    } else if (
      user &&
      pathArray[2] === "invoices" &&
      pathArray[3] === "create-supplier-bill"
    ) {
      isPermitted = !!user.permissions?.invoices?.["create"];
    } else if (
      user &&
      pathArray[2] === "agencies" &&
      pathArray[3] === "ratio-history"
    ) {
      isPermitted = !!user.permissions?.agencies?.["view-ratio-history"];
    } else if (user && user.permissions[pathArray[2]]) {
      if (pathArray[2] === "insurance-requests") {
        if (pathArray[3] === "view-all") {
          isPermitted =
            user.permissions[pathArray[2]]["view-all"] ||
            user.permissions[pathArray[2]]["view-agency"] ||
            user.permissions[pathArray[2]]["view-my"];
        }
      } else {
        isPermitted = user.permissions[pathArray[2]][pathArray[3]];
      }
    }
    if (user && pathArray[2] === "translations") {
      isPermitted = user.permissions["translations"]["modify"];
    }
    if (user && pathArray[2] === "reports") {
      if ((pathArray[3] === "agency-ratios")) {
        isPermitted =
          user.permissions["reports-section"]["discount-rates-report"];
      }
    }
    if (!isPermitted) {
      return <Redirect to={"/app" + "/home"} />;
    }
    if (location.pathname === "/") {
      if (!user.access_token) {
        return <Redirect to={"/signin"} />;
      } else {
        return <Redirect to={"/app" + "/home"} />;
      }
    }
    return (
      <RTL>
        <RctThemeProvider
          rtlLayout={this.props.user.lang === "ar" ? true : false}
        >
          <NotificationContainer />
          <InitialPath
            path={`${match.url}` + "app"}
            authUser={user ? user.access_token : null}
            component={DefaultLayout}
          />
          <Route path="/signin" component={LoginPage} />
          <Route path="/QRInsurance" component={QRPage} />
          <Route path="/Fix" component={FixBrowser} />
          <Route path="/hasiba" component={Calculator} />
        </RctThemeProvider>
      </RTL>
    );
  }
}

// map state to props
const mapStateToProps = ({ authUser, appReducer }) => {
  const { message } = appReducer;
  const { user } = authUser;
  return { user, message };
};

export default connect(mapStateToProps, { showMessage, logoutUser })(App);
